import { getCLS, getFCP, getFID, getLCP, getTTFB } from "web-vitals";

const now = () => (typeof performance !== "undefined" && performance.now ? performance.now() : Date.now());

function safeJson(obj) {
  try {
    return JSON.stringify(obj ?? {});
  } catch (_e) {
    return "{}";
  }
}

function postEvents(events) {
  if (!events || events.length === 0) return;
  const payload = safeJson({ events });
  const url = "/api/telemetry/perf";
  try {
    if (typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function") {
      navigator.sendBeacon(url, new Blob([payload], { type: "application/json" }));
      return;
    }
  } catch (_e) {}
  try {
    fetch(url, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: payload,
      keepalive: true
    }).catch(() => {});
  } catch (_e) {}
}

export function initPerfTelemetry() {
  if (typeof window === "undefined") return;
  if (window.__perfTelemetryInit) return;
  window.__perfTelemetryInit = true;

  const buffer = [];
  window.__perfEvents = buffer;

  const track = (name, valueMs, meta) => {
    const evt = {
      name: String(name || "event"),
      valueMs: Math.max(0, Number(valueMs || 0)),
      at: Date.now(),
      path: typeof window !== "undefined" ? window.location.pathname : "",
      meta: meta && typeof meta === "object" ? meta : undefined
    };
    buffer.push(evt);
    if (buffer.length > 50) buffer.splice(0, buffer.length - 50);
  };

  window.__trackPerf = track;

  const flush = () => {
    const toSend = buffer.splice(0, buffer.length);
    postEvents(toSend);
  };

  const scheduleFlush = () => {
    try {
      if (typeof requestIdleCallback === "function") {
        requestIdleCallback(() => flush(), { timeout: 1500 });
      } else {
        setTimeout(() => flush(), 800);
      }
    } catch (_e) {
      setTimeout(() => flush(), 800);
    }
  };

  const wireVital = (metricName) => (m) => {
    track(metricName, m.value, {
      id: m.id,
      rating: m.rating,
      delta: m.delta,
      navigationType: m.navigationType
    });
    scheduleFlush();
  };

  getCLS(wireVital("CLS"));
  getFCP(wireVital("FCP"));
  getFID(wireVital("FID"));
  getLCP(wireVital("LCP"));
  getTTFB(wireVital("TTFB"));

  // Basic “interaction latency” helper for app code/tests.
  window.__perfMark = (label) => {
    const t = now();
    return () => track(label, now() - t);
  };
}

